import { render, staticRenderFns } from "./PianoControlloDetail.vue?vue&type=template&id=331290ae&"
import script from "./PianoControlloDetail.vue?vue&type=script&lang=js&"
export * from "./PianoControlloDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports